import { create } from "zustand";
import { IIpGeolocDetailsStore } from "./UserIp.interfaces";

export const useIpGeolocDetailsStore = create<IIpGeolocDetailsStore>()(set => ({
    ipGeolocDetails: null,
    set: ipGeolocDetails => set({ ipGeolocDetails: { ...ipGeolocDetails } }),
    reset: () => set({ ipGeolocDetails: null }),
}));
